import { createFileRoute } from '@tanstack/react-router';
import { useAuthStore } from '@munawb/hooks';
import { redirect } from '@tanstack/react-router';
import RegisterPage from '../pages/RegisterPage';
import { getRoleRoute } from './index';

export const Route = createFileRoute('/register')({
  beforeLoad: () => {
    const { profile } = useAuthStore.getState();
    if (profile?.status === 'active') {
      throw redirect({ to: getRoleRoute(profile.role) });
    }
  },
  component: RegisterPage,
});
